module.exports = __webpack_public_path__ + "media/V103.1548e1ab.mp4";